import { TLD_GLOBALLY } from '../../../../constants/constants';
import { topDestination, TOP_DESTINATIONS } from './TopDestinationsData';

const getCurrentTld = (ebDomain: string) => {
    const ebDomainParts = ebDomain?.split('.') || [];
    return `.${ebDomainParts.splice(1).join('.')}`;
};

const getCloudfrontPrefix = (ebDomain: string) => {
    const cloudfrontPrefixes: Readonly<Record<string, string>> = Object.freeze({
        evbdev: 'd1eztp617dyzm5',
        evbqa: 'd3ajtuaqnvf0h0',
        evbstage: 'd23quzpik3ova8',
        eventbrite: 'd1n9ior3u0lhlo',
    });

    // ebDomain looks like evbdev.com / eventbrite.de / etc
    const ebDomainParts = ebDomain?.split('.') || [];
    const site = ebDomainParts[0];
    return cloudfrontPrefixes[site] || cloudfrontPrefixes.eventbrite;
};

export const useTopDestinations = (
    ebDomain: string,
    localizedCountryName: string,
): [string | null, topDestination[]] => {
    const tld = getCurrentTld(ebDomain);
    const topDestinationsWithOutImages =
        TOP_DESTINATIONS[tld] || TOP_DESTINATIONS[TLD_GLOBALLY];

    const countryDisplayName =
        tld in TOP_DESTINATIONS ? localizedCountryName : null;

    const cloudfrontPrefix = getCloudfrontPrefix(ebDomain);
    const topDestinations = topDestinationsWithOutImages.map(
        (top_destination) => ({
            ...top_destination,
            // S3 saves the image file names with underscores instead of percent signs.
            imageUrl:
                `https://${cloudfrontPrefix}.cloudfront.net/${top_destination.locationSlug}.webp`.replaceAll(
                    '%',
                    '_',
                ),
        }),
    );

    return [countryDisplayName, topDestinations];
};
